import type { User } from "@/types/app";
import { rewriteMediaUrl } from "@/lib/media-url";

export function normalizeUser(user: Record<string, unknown> | null | undefined): User | null {
  if (!user) {
    return null;
  }
  const roleId = user.role_id == null ? null : Number(user.role_id);

  return {
    id: user.id as number | string | undefined,
    roleId: Number.isNaN(roleId) ? null : roleId,
    name: user.name as string | null | undefined,
    userName: user.username as string | null | undefined,
    chatName: user.chat_name as string | null | undefined,
    avatarUrl: rewriteMediaUrl(user.avatar_url as string | null | undefined),
    email: user.email as string | null | undefined,
    isAdmin: roleId === 1 ? true : Boolean(user.is_admin),
    isFirstLogin: Boolean(user.is_first_login),
    isSubscribed: Boolean(user.is_subscribed),
    membership:
      user.membership && typeof user.membership === "object"
        ? {
            id: (user.membership as Record<string, unknown>).id as number | string | undefined,
            name: (user.membership as Record<string, unknown>).name as string | null | undefined,
            badgeUrl: rewriteMediaUrl((user.membership as Record<string, unknown>).badge_url as string | null | undefined),
            badgeColor: (user.membership as Record<string, unknown>).badge_color as string | null | undefined,
          }
        : null,
  };
}
